var _rect, _g, _g2, _g3, _g4, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultTicketImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 500,
    viewBox: "0 0 300 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 500,
    rx: 4,
    fill: "url(#paint0_linear_1299_9990)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1299_9990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 147,
    width: 177,
    height: 177,
    rx: 88.5,
    fill: "#F1CD60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4779 229.118C20.9445 216.263 -11.0859 179.727 -11.0859 179.727V328.526H410.511C410.511 328.526 390.776 314.674 376.733 308.52C346.423 295.235 319.811 308.52 292.914 296.015C270.848 285.757 233.208 251.21 210.346 242.873C164.058 225.992 125.465 245.772 66.4779 229.118Z",
    fill: "#CA5370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.341 204.97C273.578 214.076 296.255 239.955 296.255 239.955L296.255 134.556L-2.22863 134.556C-2.22863 134.556 11.7437 144.368 21.6855 148.728C43.1442 158.138 61.9852 148.728 81.0279 157.585C96.6503 164.851 123.299 189.322 139.485 195.227C172.256 207.184 199.579 193.174 241.341 204.97Z",
    fill: "#A2C166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.468 237.857C73.7895 265.601 -19.3884 259.826 -19.3884 259.826L-23.4854 123.926L192.627 127.502C192.627 127.502 189.812 171.69 175.215 194.431C160.813 216.869 145.658 224.64 122.468 237.857Z",
    fill: "#2A406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.286 287.784C278.098 293.792 317.171 287.784 317.171 287.784H319.385V329.855C319.385 329.855 128.548 411.184 107.156 325.426C101.412 302.398 69.6689 278.965 75.7136 257.67C93.5769 194.737 164.629 189.813 203.256 231.542C221.835 251.613 227.766 281.094 254.286 287.784Z",
    fill: "url(#paint1_linear_1299_9990)",
    stroke: "url(#paint2_linear_1299_9990)",
    strokeWidth: 0.885708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4502 261.427L112.811 269.14",
    stroke: "#202020",
    strokeWidth: 5.06085,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 275.378L136.976 283.092",
    stroke: "#202020",
    strokeWidth: 5.06085,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.428 288.55L159.789 296.263",
    stroke: "#202020",
    strokeWidth: 5.06085,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.781 181.133C139.965 180.085 137.644 180.707 136.596 182.522L97.8832 249.574C99.0913 250.782 99.974 252.296 100.424 253.974C101.098 256.489 100.745 259.167 99.4435 261.421C98.1421 263.676 95.9985 265.32 93.4844 265.994C91.8057 266.444 90.0535 266.436 88.4034 265.994L34.9692 358.545C33.921 360.36 34.543 362.681 36.3585 363.73L56.3766 375.287L57.6417 373.096L58.4367 371.719C59.3101 370.206 61.2446 369.688 62.7575 370.561L82.7761 382.119C84.289 382.992 84.8073 384.927 83.9339 386.44L83.1389 387.817L81.8738 390.008L101.893 401.566C103.708 402.614 106.03 401.992 107.078 400.177L157.891 312.165L160.511 307.629C159.299 306.42 158.414 304.904 157.963 303.222C157.29 300.708 157.642 298.029 158.944 295.775C160.245 293.521 162.389 291.876 164.903 291.203C166.585 290.752 168.34 290.761 169.993 291.205L208.704 224.154C209.753 222.339 209.131 220.018 207.315 218.969L141.781 181.133ZM91.0093 261.48L91.0403 261.427C90.1775 261.443 89.2994 261.232 88.4976 260.769C88.468 260.752 88.4388 260.735 88.4097 260.717L86.3069 259.503L30.5863 356.014C28.1407 360.25 29.592 365.667 33.828 368.112L58.0885 382.119L61.8074 375.678L78.8056 385.492L75.0866 391.933L99.3625 405.949C103.599 408.394 109.015 406.943 111.461 402.707L162.274 314.696L167.181 306.196L165.043 304.962C165.025 304.952 165.007 304.942 164.99 304.932C164.188 304.469 163.566 303.814 163.149 303.059L163.115 303.118C162.913 302.758 162.755 302.372 162.646 301.967C162.305 300.695 162.484 299.34 163.142 298.199C163.801 297.058 164.885 296.226 166.158 295.885C166.563 295.777 166.976 295.721 167.388 295.716L167.354 295.775C168.214 295.759 169.089 295.968 169.889 296.428L169.889 296.428L172.088 297.697L213.087 226.685C215.533 222.449 214.082 217.032 209.846 214.587L144.311 176.75C140.075 174.305 134.659 175.756 132.213 179.992L91.2139 251.004L93.3976 252.265L93.397 252.266L93.4045 252.27C94.2063 252.733 94.828 253.388 95.2451 254.144L95.2773 254.088C95.4771 254.445 95.6337 254.828 95.7413 255.229C96.0822 256.501 95.9038 257.857 95.2452 258.998C94.5867 260.138 93.502 260.971 92.2297 261.311C91.8281 261.419 91.4182 261.475 91.0093 261.48Z",
    fill: "#202020"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1299_9990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 287,
    r: 5,
    fill: "#CA5370"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1299_9990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 132,
    r: 5,
    fill: "#CA5370"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1299_9990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 76,
    r: 5,
    fill: "#9C6EBA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1299_9990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 373,
    r: 5,
    fill: "#A2C166"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1299_9990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 416,
    r: 5,
    fill: "#6CBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1299_9990",
    x: 239,
    y: 270,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.321569 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1299_9990",
    x: 33,
    y: 115,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.321569 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1299_9990",
    x: 176,
    y: 59,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.431373 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1299_9990",
    x: 63,
    y: 356,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635294 0 0 0 0 0.756863 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1299_9990",
    x: 200,
    y: 399,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.756863 0 0 0 0 0.752941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1299_9990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1299_9990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1299_9990",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1299_9990",
    x1: 197.169,
    y1: 204.489,
    x2: 197.169,
    y2: 364.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1299_9990",
    x1: 197.169,
    y1: 204.489,
    x2: 197.169,
    y2: 364.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FABAB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1299_9990"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 147,
    width: 177,
    height: 177,
    rx: 88.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTicketImage);
export default __webpack_public_path__ + "static/media/defaultTicketImage.c3cd9d50bd7f9fbcd6dafa40169b52a1.svg";
export { ForwardRef as ReactComponent };